import Vue from "vue";
//System seetings
import VueRouter from "vue-router";
import Home from "../components/Dashboard/Home";
import Menu from "../components/Menu";
import Status from "../views/application/Status";
import AuthHandler from "../views/auth/AuthHandler";
import Signin from "../views/auth/Signin";
import Signup from "../views/auth/Signup";
import NidStatus from "../views/clementine/NidStatus";
import AssignDasherToTeam from "../views/clementine/Team/AssignDasherToTeam";
import CreateTeam from "../views/clementine/Team/CreateTeam";
import DasherTeamStatus from "../views/clementine/Team/DasherTeamStatus";
import CashWithdrawStatus from "../views/dasher-wallet/CashWithdrawStatus";
import TaskStatus from "../views/response/TaskStatus";
// import ProjectPaymentStatus from '../views/clementine/PaymentStatuses/PaymentStatus'
import UserProfile from "../components/UserProfile";
import General from "../views/profile/General";
import Password from "../views/profile/Password";
import Subscription from "../views/profile/Subscription";
import Transaction from "../views/profile/Transaction";
import Contacts from "../views/setting/Contacts";
import DefaultMeta from "../views/setting/DefaultMeta";
import District from "../views/setting/District";
import Division from "../views/setting/Division";
import Education from "../views/setting/Education";
import Faq from "../views/setting/Faq";
import FaqClient from "../views/setting/FaqClient";
import Gender from "../views/setting/Gender";
import IncomeType from "../views/setting/IncomeType";
import MaritalStatus from "../views/setting/MaritalStatus";
import MiscellaneousSetting from "../views/setting/MiscellaneousSetting";
import MonthlyIncome from "../views/setting/MonthlyIncome";
import NearbyProjectRadius from "../views/setting/NearbyProjectRadius";
import Occupation from "../views/setting/Occupation";
import OtpCredential from "../views/setting/OtpCredential";
import OtpSms from "../views/setting/OtpSms";
import ProjectStatus from "../views/setting/ProjectStatus";
import ProjectType from "../views/setting/ProjectTypes";
import Upazila from "../views/setting/Upazila";
//user role permission
import Role from "../views/user-role-permission/Role";
import RoleToUser from "../views/user-role-permission/RoleToUser";
import UpdatePassword from "../views/user-role-permission/UpdatePassword";
import Url from "../views/user-role-permission/Url";
import UrlToRole from "../views/user-role-permission/UrlToRole";
import User from "../views/user-role-permission/User";
import UserManagement from "../views/UserManagement";
import TeamManagement from "../views/TeamManagement";
import AgentManagement from "../views/AgentManagement";
//Marketplace setting
import CoinMessage from "../views/marketplace/CoinMessage";
import CoinRule from "../views/marketplace/CoinRule";
import PointMessage from "../views/marketplace/PointMessage";
import PointRule from "../views/marketplace/PointRule";
import Rank from "../views/marketplace/Rank";
import WalletType from "../views/marketplace/WalletType";
//project module
import Address from "../views/project/Address.vue";
import BudgetPage from "../views/project/BudgetPage.vue";
import AllProject from "../views/project/client/AllProject.vue";
import ProjectDetails from "../views/project/client/ProjectDetails.vue";
import ProjectResponse from "../views/project/client/ProjectResponse.vue";

import ClientView from "../views/project/ClientView.vue";
import DateTime from "../views/project/components/DateTime.vue";
import CreateProject from "../views/project/CreateProject.vue";
import CreateProjectEdit from "../views/project/CreateProjectEdit.vue";
import DynamicQuestion from "../views/project/DynamicQuestion.vue";
import LocationBasedBudget from "../views/project/LocationBasedBudget.vue";
import PreSurveyQuestion from "../views/project/PreSurveyQuestion.vue";
import ProjectFiltering from "../views/project/ProjectFiltering.vue";
import ProjectList from "../views/project/ProjectList.vue";
import ProjectPreview from "../views/project/ProjectPreview.vue";
import ProjectPreviewNew from "../views/project/ProjectPreviewNew.vue";
import ProjectResponseAnalytics from "../views/project/ProjectResponseAnalytics.vue";
import ProjectResponses from "../views/project/ProjectResponses.vue";
import ProjectSummary from "../views/project/ProjectSummary.vue";
import ComparisonOperator from "../views/project/setting/comparisonOperator.vue";
import ConditionalOrder from "../views/project/setting/ConditionalOrder.vue";
import Project from "../views/project/setting/project.vue";
import ProjectFilteringParameter from "../views/project/setting/projectFilteringParameter.vue";
import ProjectFilteringSettings from "../views/project/setting/projectFilteringSettings.vue";
import Question from "../views/project/setting/Question.vue";
import QuestionOption from "../views/project/setting/QuestionOption.vue";
import QuestionOrder from "../views/project/setting/QuestionOrder.vue";
import QuestionResponseSetting from "../views/project/setting/QuestionResponseSetting.vue";
import QuestionTypes from "../views/project/setting/QuestionTypes.vue";
import QuestionTypeSetting from "../views/project/setting/QuestionTypeSettings.vue";
import UiCategories from "../views/project/setting/UiCategories.vue";
import UiComponent from "../views/project/setting/UiComponent.vue";
import ValidatingParameter from "../views/project/setting/ValidatingParameter.vue";
import Temporary from "../views/project/Temporary.vue";
//Modification route module.................
import EditAddress from "../views/project/modification/EditAddress.vue";
import EditAssignTeamToProject from "../views/project/modification/EditAssignTeamToProject.vue";
import EditBudget from "../views/project/modification/EditBudget.vue";
import EditFiltering from "../views/project/modification/EditFiltering.vue";
import EditBudget2 from "../views/project/modification/EditLocationBasedBudget.vue";
import EditPreSurveyQuestion from "../views/project/modification/EditPreSurveyQuestion.vue";
import EditProject from "../views/project/modification/EditProject.vue";
import EditProjectPreview from "../views/project/modification/EditProjectPreview.vue";
import EditQuestion from "../views/project/modification/EditQuestion.vue";
//Payment Method.........................................
import SearchInResponse from "../views/clementine/SearchInResponse/SearchInResponse.vue";
import PaymentMethod from "../views/project/PaymentMethod/PaymentMethod.vue";
import SuccessPay from "../views/project/PaymentMethod/SuccessPayment.vue";
import ProjectReportDetails from "../views/Reports/ProjectReports/ProjectReportDetails.vue";
import ProjectReportResponse from "../views/Reports/ProjectReports/ProjectReportResponse.vue";

Vue.use(VueRouter);

export default new VueRouter({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    //authentication
    {
      path: "/oauth2/callback",
      name: "auth handler",
      component: AuthHandler,
    },
    {
      path: "/signin",
      name: "signin",
      component: Signin,
    },
    {
      path: "/signup",
      name: "signup",
      component: Signup,
    },

    {
      path: "/reset-password",
      name: "reset-password",
      component: () => import("@/views/auth/ResetPassword"),
    },

    {
      path: "/verify-pin",
      name: "verify-pin",
      component: () => import("@/views/auth/VerifyPin"),
    },

    {
      path: "/forgot-password",
      component: () => import("@/views/auth/ForgotPassword"),
    },

    {
      path: "/menu",
      name: "menu",
      component: Menu,
    },
    //admin
    {
      path: "/description",
      component: () => import("../components/HowItWorks"),
    },
    {
      path: "/price",
      component: () => import("../components/SubscriptionPrice/PriceComponent"),
    },
    {
      path: "/all-status",
      component: () => import("../components/ApprovalStatus/AllApprovalStatus"),
    },
    {
      path: "/client-payment-page",
      component: () => import("../components/PaymentPage"),
    },
    {
      path: "/subscription-payment-page",
      name: "Subscription Payment Page",
      component: () => import("../components/SubscriptionPaymentPage"),
    },
    {
      path: "/status",
      name: "Project Status",
      component: Status,
    },
    {
      path: "/nid-status",
      name: "Nid Status",
      component: NidStatus,
    },
    {
      path: "/cash-withdraw",
      name: "Cash Withdraw",
      component: CashWithdrawStatus,
    },
    {
      path: "/nagad-cashout",
      component: () => import("../views/clementine/NagadCashout/Status"),
    },
    {
      path: "/mobile-recharge",
      component: () => import("../views/clementine/MobileRecharge/Status"),
    },
    {
      path: "/payment-status",
      component: () =>
        import("../views/clementine/PaymentStatuses/PaymentStatus"),
    },
    {
      path: "/balance-withdraw",
      component: () =>
        import("../views/clementine/ClientBalanceWithdraw/Status"),
    },
    {
      path: "/:id/search-in-response",
      name: "Search In Response",
      component: SearchInResponse,
    },
    {
      path: "/user-device-info",
      name: "User Device Infs",
      component: () =>
        import("../views/clementine/UserDeviceInfo/UserDeviceInfos"),
    },
    // user delete request
    {
      path: "/user-delete-request",
      name: "User Delete Request",
      component: () =>
        import("../views/UserDeleteRequest/UserDeleteRequest.vue"),
    },
    {
      path: "/dasher-delete-request",
      name: "Dasher Delete Request",
      component: () =>
        import("../views/UserDeleteRequest/DasherDeleteRequest.vue"),
    },
    //create client
    {
      path: "/client",
      name: "Client",
      component: () => import("../views/clementine/CreateClient"),
    },
    //create client
    {
      path: "/assistant-request",
      name: "Assistant Request",
      component: () => import("../views/clementine/NeedAssistantRequest"),
    },
    {
      path: "/demo-request",
      name: "Demo Request",
      component: () => import("../views/clementine/DemoRequest"),
    },

    //Agent
    {
      path: "/agent-group",
      name: "Agent Group",
      component: () => import("../views/Agent/AgentGroup"),
    },
    {
      path: "/assign-agent-to-group",
      name: "Assign Agent To Group",
      component: () => import("../views/Agent/AssignAgentToGroup"),
    },
    {
      path: "/assign-agent-to-group-status",
      name: "Assign Agent Group Status",
      component: () => import("../views/Agent/AgentStatus/AgentRequestStatus"),
    },

    //client

    {
      path: "/create-team",
      name: "Create Team",
      component: CreateTeam,
    },
    {
      path: "/assign-dasher-to-team",
      name: "Assign Dasher To Team",
      component: AssignDasherToTeam,
    },
    {
      path: "/dasher-team-status",
      name: "Dasher Team Status",
      component: DasherTeamStatus,
    },
    {
      path: "/task-status",
      name: "Task Status",
      component: TaskStatus,
    },
    //user profile
    {
      path: "/profile",
      name: "Profile",
      component: General,
    },
    {
      path: "/profile/subscription",
      name: "subscription",
      component: Subscription,
    },
    {
      path: "/profile/transaction",
      name: "Transaction",
      component: Transaction,
    },
    {
      path: "/profile/password",
      name: "Password",
      component: Password,
    },

    {
      path: "/user-profile",
      name: "User Profile",
      component: UserProfile,
    },

    //System Setting
    {
      path: "/division",
      name: "Division",
      component: Division,
    },
    {
      path: "/district",
      name: "District",
      component: District,
    },
    {
      path: "/upazila",
      name: "Upazila",
      component: Upazila,
    },
    {
      path: "/gender",
      name: "Gender",
      component: Gender,
    },
    {
      path: "/default-meta",
      name: "Default Meta",
      component: DefaultMeta,
    },
    {
      path: "/miscellaneous-setting",
      name: "Miscellaneous Setting",
      component: MiscellaneousSetting,
    },
    {
      path: "/marital-status",
      name: "Marital Status",
      component: MaritalStatus,
    },
    {
      path: "/contacts",
      name: "Contacts",
      component: Contacts,
    },
    {
      path: "/otp-credential",
      name: "Otp Credential",
      component: OtpCredential,
    },
    {
      path: "/otp-sms",
      name: "Otp Sms",
      component: OtpSms,
    },
    {
      path: "/faq",
      name: "Faq",
      component: Faq,
    },
    {
      path: "/faq-client",
      name: "FaqClient",
      component: FaqClient,
    },
    {
      path: "/education",
      name: "Education Qualification Type",
      component: Education,
    },
    {
      path: "/income-type",
      name: "Income Type",
      component: IncomeType,
    },
    {
      path: "/occupation-type",
      name: "Occupation",
      component: Occupation,
    },
    {
      path: "/monthly-income",
      name: "Monthly Income",
      component: MonthlyIncome,
    },
    {
      path: "/notify-message",
      component: () => import("../views/setting/NotificationMessage.vue"),
    },
    {
      path: "/gateway-charge",
      component: () => import("../views/setting/PaymentGatewayCharge.vue"),
    },

    //project settings
    {
      path: "/project-type",
      name: "Project Type",
      component: ProjectType,
    },
    {
      path: "/project-status",
      name: "Project Statuses",
      component: ProjectStatus,
    },
    {
      path: "/nearby-radius",
      name: "Nearby Distance",
      component: NearbyProjectRadius,
    },
    {
      path: "/comparison-operator",
      name: "Comparison Operator",
      component: ComparisonOperator,
    },
    {
      path: "/project-filtering-parameter",
      name: "Project Filtering Parameter",
      component: ProjectFilteringParameter,
    },
    {
      path: "/project-filtering-setting",
      name: "Project Filtering Settings",
      component: ProjectFilteringSettings,
    },
    {
      path: "/ui-category",
      name: "Ui Category",
      component: UiCategories,
    },
    {
      path: "/ui-component",
      name: "Ui Components",
      component: UiComponent,
    },
    {
      path: "/question-type",
      name: "Question Types",
      component: QuestionTypes,
    },
    {
      path: "/question-type-settings",
      name: "Question Type Settings",
      component: QuestionTypeSetting,
    },
    {
      path: "/question",
      name: "Questions",
      component: Question,
    },
    {
      path: "/validating-parameter",
      name: "Validating Parameter",
      component: ValidatingParameter,
    },
    {
      path: "/question-response-setting",
      name: "Question Response Setting",
      component: QuestionResponseSetting,
    },
    {
      path: "/question-option",
      name: "Question Option",
      component: QuestionOption,
    },
    {
      path: "/question-order",
      name: "Question Order",
      component: QuestionOrder,
    },
    {
      path: "/conditional-order",
      name: "Conditional Order",
      component: ConditionalOrder,
    },
    {
      path: "/project-filtering",
      name: "ProjectFilterings",
      component: ProjectFiltering,
    },
    {
      path: "/edit-filtering",
      name: "Edit Filtering",
      component: EditFiltering,
    },

    //Marketplace setting
    {
      path: "/wallet-type",
      name: "Wallet Type",
      component: WalletType,
    },
    {
      path: "/point-message",
      name: "Point Message",
      component: PointMessage,
    },
    {
      path: "/point-rule",
      name: "Point Rule",
      component: PointRule,
    },
    {
      path: "/rank",
      name: "Rank",
      component: Rank,
    },
    {
      path: "/coin-message",
      name: "Coin Message",
      component: CoinMessage,
    },
    {
      path: "/coin-rule",
      name: "Coin Rule",
      component: CoinRule,
    },
    {
      path: "/user-management",
      name: "User Management",
      component: UserManagement,
    },
    {
      path: "/team-management",
      name: "Team Management",
      component: TeamManagement,
    },
    {
      path: "/agent-management",
      name: "Agent Management",
      component: AgentManagement,
    },
    //user role permission
    {
      path: "/url",
      name: "Url",
      component: Url,
    },
    {
      path: "/role",
      name: "Role",
      component: Role,
    },
    {
      path: "/official-user",
      name: "User",
      component: User,
    },
    {
      path: "/url-role",
      name: "UrlToRole",
      component: UrlToRole,
    },
    {
      path: "/role-user",
      name: "RoleToUser",
      component: RoleToUser,
    },
    {
      path: "/update-password",
      name: "UpdatePassword",
      component: UpdatePassword,
    },

    //project module
    {
      path: "/create-project",
      name: "Create New Project",
      component: CreateProject,
    },
    {
      path: "/create-project-edit",
      name: "Edit created Project",
      component: CreateProjectEdit,
    },
    {
      path: "/dynamic-question",
      name: "Dynamic Questions",
      component: DynamicQuestion,
    },
    {
      path: "/pre-survey-question",
      name: "Pre-survey Questions",
      component: PreSurveyQuestion,
    },
    {
      path: "/project",
      name: "Project",
      component: Project,
    },
    {
      path: "/project-list",
      name: "Project List",
      component: ProjectList,
    },

    {
      path: "/project/:id/responses",
      name: "ProjectResponses",
      component: ProjectResponses,
    },

    {
      path: "/project/:id/summary",
      name: "Project Summary",
      component: ProjectSummary,
    },
    {
      path: "/project/:id/preview",
      name: "ProjectPreview",
      component: ProjectPreviewNew,
    },
    {
      path: "/project/:id/project-settings",
      name: "Preview Project Settings",
      component: () => import("../views/project/PreviewProjectSettings.vue"),
    },
    {
      path: "/project/:id/response-analytics",
      name: "Project Response Analytics",
      component: ProjectResponseAnalytics,
    },
    {
      path: "/assign-teams-to-Project",
      name: "Assign Teams To Project",
      component: () => import("../views/project/AssignTeamToProject.vue"),
    },
    {
      path: "/:id/project-settings",
      name: "Project Settings",
      component: () => import("../views/project/ProjectSettings.vue"),
    },
    {
      path: "/assign-agent-groups-to-project",
      name: "Assign Agent Groups To Project",
      component: () => import("../views/project/AssignAgentGroupToProject.vue"),
    },
    {
      path: "/define-project-task-to-agents",
      name: "Define Project Task To Agent",
      component: () => import("../views/project/DefineProjectTaskToAgent.vue"),
    },
    {
      path: "/define-task-to-agents",
      name: "Define Task To Agent",
      component: () => import("../views/Agent/DefineProjectTaskToAgent.vue"),
    },
    {
      path: "/edit-define-project-task-to-agent",
      name: "Edit Define Project Task To Agent",
      component: () =>
        import(
          "../views/project/modification/EditDefineProjectTaskToAgent.vue"
        ),
    },
    {
      path: "/edit-assign-agent-groups-to-project",
      name: "Edit Assign Agent Groups To Project",
      component: () =>
        import(
          "../views/project/modification/EditAssignAgentGroupToProject.vue"
        ),
    },
    {
      path: "/budget",
      name: "Budget Page",
      component: BudgetPage,
    },
    {
      path: "/budget2",
      name: "Location Based Budget",
      component: LocationBasedBudget,
    },
    {
      path: "/:id/project-preview",
      name: "Project Preview",
      component: ProjectPreview,
    },
    {
      path: "/date",
      name: "Date Time",
      component: DateTime,
    },
    {
      path: "/address",
      name: "Address",
      component: Address,
    },
    {
      path: "/temporary",
      name: "Temporary",
      component: Temporary,
    },
    {
      path: "/client-view",
      name: "Client View",
      component: ClientView,
    },
    //project modification route
    {
      path: "/edit-project",
      name: "Edit Project",
      component: EditProject,
    },
    {
      path: "/edit-question",
      name: "Edit Question",
      component: EditQuestion,
    },
    {
      path: "/edit-pre-survey-question",
      name: "Edit Pre Survey Question",
      component: EditPreSurveyQuestion,
    },
    {
      path: "/edit-assign-teams-to-project",
      name: "Edit Assign Teams To Project",
      component: EditAssignTeamToProject,
    },
    {
      path: "/edit-address",
      name: "Edit Address",
      component: EditAddress,
    },
    {
      path: "/edit-budget",
      name: "Edit Budget",
      component: EditBudget,
    },
    {
      path: "/edit-budget2",
      name: "Edit Budget2",
      component: EditBudget2,
    },
    {
      path: "/edit-project-preview",
      name: "edit project preview",
      component: EditProjectPreview,
    },
    {
      path: "/projects-location",
      name: "Project locations",
      component: () =>
        import("../views/project/components/PreviewLocation.vue"),
    },
    {
      path: "/payment-page",
      name: "Payment Page",
      component: () =>
        import("../views/project/PaymentMethod/PaymentPageNew.vue"),
    },
    {
      path: "/payment-method",
      name: "Payment Method",
      component: PaymentMethod,
    },
    {
      path: "/client-balance-withdraw",
      name: "Client Balance Withdraw",
      component: () =>
        import("../views/ClientBalanceWithdraw/ClientBalanceWithdraw.vue"),
    },
    {
      path: "/remaining-payment-page",
      name: "Remaing Payment Page",
      component: () =>
        import("../views/project/PaymentMethod/RemainingPaymentPage.vue"),
    },
    {
      path: "/remaining-payment-method",
      name: "Remaing Payment Method",
      component: () =>
        import("../views/project/PaymentMethod/RemainingPaymentMethod.vue"),
    },
    {
      path: "/success-pay",
      name: "Success Pay",
      component: SuccessPay,
    },
    {
      path: "/all-project",
      name: "All Projects",
      component: AllProject,
    },
    {
      path: "/project-details",
      name: "Project Details",
      component: ProjectDetails,
    },
    {
      path: "/project-response",
      name: "Project Responses",
      component: ProjectResponse,
    },
    {
      path: "/project-summary-report",
      name: "Project Summary Report",
      component: () =>
        import("../views/Reports/ProjectReports/ProjectSummaryReport.vue"),
    },
    {
      path: "/:id/project-report-details",
      name: "Project Report Details",
      component: ProjectReportDetails,
    },
    {
      path: "/project-report-response",
      name: "Project Report Response",
      component: ProjectReportResponse,
    },
    {
      path: "/dasher-summary-report",
      name: "Dasher Summary Report",
      component: () =>
        import("../views/Reports/DasherReports/DasherSummaryReport.vue"),
    },
    {
      path: "/dasher-details-report",
      name: "Dasher Details Report",
      component: () =>
        import("../views/Reports/DasherReports/DasherDetailsReport.vue"),
    },
    {
      path: "/dasher-cash-out-report",
      name: "Dasher Cash Out Report",
      component: () =>
        import("../views/Reports/DasherReports/DasherCashOutDetails.vue"),
    },
    {
      path: "/dasher-rank-details-report",
      name: "Dasher Rank Details Report",
      component: () =>
        import("../views/Reports/DasherReports/DasherRankDetails.vue"),
    },
    {
      path: "/dasher-coin-balance-report",
      name: "Dasher coin balance Report",
      component: () =>
        import(
          "../views/Reports/AccountingReports/DasherCoinBalanceReport.vue"
        ),
    },
    {
      path: "/dasher-daily-cash-out-report",
      name: "Dasher Daily Cash Out Report",
      component: () =>
        import("../views/Reports/AccountingReports/DasherCashOutReport.vue"),
    },
    {
      path: "/dasher-response-report",
      name: "Dasher Response Report",
      component: () =>
        import("../views/Reports/DasherResponseReports/HomePage.vue"),
    },
    //subscriptions routes//
    {
      path: "/service",
      name: "Service",
      component: () => import("../views/Subscriptions/Services.vue"),
    },
    {
      path: "/package",
      name: "Package",
      component: () => import("../views/Subscriptions/Package.vue"),
    },
    {
      path: "/package-price",
      name: "Package Price",
      component: () => import("../views/Subscriptions/PackagePrice.vue"),
    },
    {
      path: "/package-ui-category",
      name: "Package UiCategory",
      component: () => import("../views/Subscriptions/PackageUiCategory.vue"),
    },
    {
      path: "/package-detail",
      name: "Package Detail",
      component: () => import("../views/Subscriptions/PackageDetails.vue"),
    },
    {
      path: "/subscription-package",
      name: "Subscription Package",
      component: () => import("../views/Subscriptions/SubscriptionPackage.vue"),
    },
    {
      path: "/subscription-price",
      name: "Subscription Package Price",
      component: () => import("../views/Subscriptions/SubscriptionPackage.vue"),
    },
    {
      path: "/client-subscription-plan",
      name: "Client's Subscription Plan",
      component: () =>
        import("../views/Subscriptions/ClientSubscriptionsPlan.vue"),
    },

    {
      path: "/subscriptionPayment-method",
      name: "Subscription Payment method",
      component: () =>
        import(
          "../views/project/SubscriptionPayment/SubscriptionPaymentMethod.vue"
        ),
    },
    {
      path: "/package-comparison",
      name: "Package Feature Comparison",
      component: () => import("../components/PackageFeatureComparison.vue"),
    },

    //default logic
    {
      path: "/privacy-policy-en",
      name: "Privacy Policy English",
      component: () =>
        import("../components/PrivacyPolicy/PrivacyPolicyEn.vue"),
    },
    {
      path: "/subscription-terms&conditions",
      name: "Subscription Policy",
      component: () =>
        import("../components/SubscriptionTermsAndCondition.vue"),
    },
    {
      path: "/terms-&-conditions",
      name: "Terms & Conditions",
      component: () =>
        import("../components/TermsAndConditions/TermsAndConditions.vue"),
    },
    {
      path: "/payment-success",
      name: "Success",
      component: () =>
        import("../components/PaymentMessages/PaymentSuccess.vue"),
    },
    {
      path: "/payment-rejected",
      name: "Payment Rejected",
      component: () =>
        import("../components/PaymentMessages/PaymentRejected.vue"),
    },
    {
      path: "/money-payment-rejected",
      name: "Rejected",
      component: () =>
        import("../components/PaymentMessages/MoneyPaymentRejected.vue"),
    },
    {
      path: "/company-docs",
      name: "Company Documents",
      component: () => import("../components/CompanyDocs.vue"),
    },
  ],
  mode: "hash",
});
